import { IoIosPrint } from "react-icons/io";

import { Tooltip } from "react-tooltip";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import Search from "../../Search/Search";

export default function Import_Question() {
  return (
    <>
      <Row>
        <Col>
          <Title title="سحب الاسئلة" />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="رمز المقرر / اسم المقرر"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>

      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td> رمز المقرر </td>
                <td> اسم المقرر </td>
                <td> اسم القاعة</td>
                <td> عدد الطلاب المفروزين لهذه القاعة </td>
                <td>امكانية الطباعة</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td>12541</td>
                <td>برمجة</td>
                <td> القاعة الرابعة</td>
                <td>120</td>
                <td>
                  <div
                    id="print"
                    className="flex justify-center cursor-pointer"
                  >
                    <IoIosPrint size={30} className="text-red-700" />
                    <Tooltip
                      anchorSelect="#print"
                      style={{ background: "#475569" }}
                    >
                      <button> طباعة </button>
                    </Tooltip>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
}
